import React from 'react';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { GrFormClose } from 'react-icons/gr';
const NewMessageNotification = (props) => {

    const refreshInboxList = (event) => {
        props.handleMemoPopup();
        props.setNotification(true);
    }

    const handleNotificationPopup=(event)=>{
        props.handleMemoPopup();
        props.setNotification(false);
    }
    return (
        <div className='popup-box'>
             <span className="close" onClick={() => handleNotificationPopup()} ><GrFormClose /></span>
            <h4 className="title">{props.t('attention')} !</h4>
            <p>{props.t('please_check_your_memo_you_have')} {props.t('message_from_operator')} !</p>
            <div className="text-center pt-2">
            <button onClick={refreshInboxList}
             >{props.t('read')}</button>
            </div>
            
        </div>
    )
}

NewMessageNotification.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(NewMessageNotification);